import { render, staticRenderFns } from "./policy-set.vue?vue&type=template&id=b8fb43ac"
import script from "./policy-set.vue?vue&type=script&lang=js"
export * from "./policy-set.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8fb43ac')) {
      api.createRecord('b8fb43ac', component.options)
    } else {
      api.reload('b8fb43ac', component.options)
    }
    module.hot.accept("./policy-set.vue?vue&type=template&id=b8fb43ac", function () {
      api.rerender('b8fb43ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/monitoring-operation/policy-set.vue"
export default component.exports